import React, { useState, useEffect } from "react";
import { SERVER_HTTP } from "./serverConfig";

const ColourPicker = () => {
  const [color, setColor] = useState("#ffffff");
  const [status, setStatus] = useState("");
  const [liveColor, setLiveColor] = useState("#ffffff"); // State for live color from server

  const handleColorChange = (e) => {
    setColor(e.target.value);
    setStatus(""); // Clear status when color changes
  };

  const sendColorToDiscoBall = async () => {
    setStatus("Sending...");
    // Encode the color value to ensure it's safe for URL
    const encodedColor = encodeURIComponent(color);
    try {
      // Append the color as a query parameter
      const response = await fetch(`${SERVER_HTTP}/disco?hex=${encodedColor}`, {
        method: "POST",
      });
      // Check if the response is ok
      if (!response.ok) {
        setStatus(`Error: ${response.status} ${response.statusText}`);
        return;
      }
      // Attempt to parse JSON, handle potential errors if response is not JSON
      try {
        const data = await response.json();
        if (data.error) {
          setStatus("Error: " + data.error);
        } else {
          setStatus("Color sent!");
        }
      } catch (jsonError) {
        // Handle cases where the response is not valid JSON (e.g., empty response on success)
        console.log(
          "Response might not be JSON, assuming success based on status code.",
        );
        setStatus("Color sent!");
      }
    } catch (err) {
      console.error("Network error:", err);
      setStatus("Network error");
    }
  };

  // Effect to poll for the current color
  useEffect(() => {
    const fetchLiveColor = async () => {
      try {
        const response = await fetch("http://86.157.76.90:3131/disco/current");
        if (!response.ok) {
          console.error(
            `Error fetching live color: ${response.status} ${response.statusText}`,
          );
          return;
        }
        const data = await response.json();
        const { r, g, b, w } = data.colour; // Extract RGBW values
        // Convert RGBW to RGB by mixing with white
        const maxColorValue = 255;
        const whiteRatio = w / maxColorValue;
        const mixedR = Math.round(
          r * (1 - whiteRatio) + whiteRatio * maxColorValue,
        );
        const mixedG = Math.round(
          b * (1 - whiteRatio) + whiteRatio * maxColorValue,
        );
        const mixedB = Math.round(
          g * (1 - whiteRatio) + whiteRatio * maxColorValue,
        );
        const hexColor =
          "#" +
          [mixedR, mixedG, mixedB]
            .map((x) => x.toString(16).padStart(2, "0"))
            .join("");
        setLiveColor(hexColor);
      } catch (err) {
        console.error("Error fetching or parsing live color:", err);
      }
    };

    fetchLiveColor(); // Fetch immediately on mount
    const intervalId = setInterval(fetchLiveColor, 3000); // Poll every 3 seconds

    return () => clearInterval(intervalId); // Cleanup interval on unmount
  }, []); // Empty dependency array ensures this runs only once on mount

  return (
    <div
      style={{
        display: "inline-block",
        margin: "2rem",
        justifySelf: "flex-end",
      }}
    >
      {/* Live Color Viewer */}
      <div style={{ marginBottom: "15px", textAlign: "center" }}>
        <div
          style={{ fontWeight: "bold", marginBottom: "5px", color: "black" }}
        >
          Live Disco Colour:
        </div>
        <div
          style={{
            width: "100px",
            height: "50px",
            backgroundColor: liveColor,
            border: "1px solid #555",
            borderRadius: "4px",
            display: "inline-block",
            verticalAlign: "middle",
          }}
        ></div>
        <span
          style={{
            fontFamily: "monospace",
            fontSize: "1.1em",
            padding: "5px",
            backgroundColor: "#eee",
            borderRadius: "4px",
            marginLeft: "10px",
            verticalAlign: "middle",
          }}
        >
          {liveColor}
        </span>
      </div>
      {/* Color Picker Controls */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "10px", // Increased gap
          padding: "15px", // Added padding
          border: "1px solid #ccc", // Added border
          borderRadius: "8px", // Added border radius
          backgroundColor: "#e1e1e1", // Added background color
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)", // Added subtle shadow

          color: "black",
        }}
      >
        <label
          htmlFor="colorPicker"
          style={{ fontWeight: "bold", marginBottom: "5px" }}
        >
          Select Colour:
        </label>
        <input
          id="colorPicker"
          type="color"
          value={color}
          onChange={handleColorChange}
          style={{
            width: "80px", // Increased width
            height: "50px", // Increased height
            border: "1px solid #ddd", // Added subtle border
            borderRadius: "4px", // Rounded corners for the picker itself
            cursor: "pointer", // Pointer cursor
          }}
        />
        <span
          style={{
            fontFamily: "monospace",
            fontSize: "1.1em",
            padding: "5px",
            backgroundColor: "#eee",
            borderRadius: "4px",
          }}
        >
          {color}
        </span>
        <button
          onClick={sendColorToDiscoBall}
          style={{
            padding: "10px 15px",
            fontSize: "1em",
            cursor: "pointer",
            backgroundColor: "#007bff",
            color: "white",
            border: "none",
            borderRadius: "5px",
            marginTop: "10px", // Added margin top
          }}
          disabled={status === "Sending..."} // Disable button while sending
        >
          {status === "Sending..." ? "Sending..." : "Send to Disco Ball"}
        </button>
        {status &&
          status !== "Sending..." && ( // Don't show 'Sending...' message here
            <div
              style={{
                marginTop: "10px",
                color: status.startsWith("Error") ? "red" : "green",
                fontWeight: "bold",
              }}
            >
              {status}
            </div>
          )}
      </div>
    </div>
  );
};

export default ColourPicker;
